import { PopoverTheme } from '../../types';

export const POPOVER_DEFAULT_THEME: PopoverTheme = {
    animationDuration: {
        open: 250,
        close: 100,
    },
};
